import AppResource from 'ss-js-engine/src/Data/AppResource';

export const HOME_PURCHASE = 'homePurchase';
export const HOME_SALE = 'homeSale';
export const HOME_OWNERSHIP = 'homeOwnership';
export const MOVE = 'move';
export const HOME_IMPROVEMENT = 'homeImprovement';
export const MORTGAGE = 'mortgage';
export const REFINANCE = 'refinance';

export const TYPE = {
    HOME_PURCHASE,
    HOME_SALE,
    HOME_OWNERSHIP,
    MOVE,
    HOME_IMPROVEMENT,
    MORTGAGE,
    REFINANCE,
};

class WorkspaceTypeAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Workspace-Type';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'workspaces/types';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
            'created_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'type',
            'name',
            'organizationUuid',
            'ownerOrganizationMemberUuid',
            'isSystem',
            'meta',
            'isActive',
            'sort',
            'description',
        ];
    }

    /**
     * @return {{}}
     */
    relationMap() {
        return {
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            type: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            name: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            isSystem: {
                type: 'boolean',
                presence: true,
            },
            meta: {
                type: 'object',
                presence: false,
            },
            isActive: {
                type: 'boolean',
            },
        };
    }

}

export default WorkspaceTypeAppResource;
